import { render, staticRenderFns } from "./Kill_Alert.vue?vue&type=template&id=6211014d&scoped=true"
import script from "./Kill_Alert.vue?vue&type=script&lang=js"
export * from "./Kill_Alert.vue?vue&type=script&lang=js"
import style0 from "./Kill_Alert.vue?vue&type=style&index=0&id=6211014d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6211014d",
  null
  
)

export default component.exports